import { BaseApi } from "./Base";

class BadgeApi extends BaseApi {
  getBadges(includeCounts) {
    return super.getApiRequest("/badges", { includeCounts });
  }

  createBadge(data) {
    return super.postApiRequest("/badges", data);
  }

  editBadge(id, data) {
    return super.putApiRequest(`/badges/${id}`, data);
  }

  deleteBadge(id) {
    return super.deleteApiRequest(`/badges/${id}`);
  }
}

const badgeApi = new BadgeApi();

export default badgeApi;
